import React from 'react';
import { StyledVideoFullSection } from './StyledVideoFullSection';
import { useHistory } from 'react-router-dom'
import { useDispatch } from "react-redux";
import {
  setLoader,
} from "../../redux/loader/loader.actions";

const VideoFullSection = ({ bgColor, title, text, align, children, black, route, noMarginBottom, extraTopPadding, extraBottom,zIndex,noPaddingParent,supTitle }) => {
  let history = useHistory();

  const dispatch = useDispatch();
  const handleCLick = (slug) => {
    
    if(history.location.pathname !== slug){
      dispatch(setLoader(true))
      
      setTimeout(() =>{ 
        document.body.scrollTop = 0;
        history.push(slug)
      }, 500);
    }
  }

  return (
    <React.Fragment>
      {
       
          <StyledVideoFullSection
            bgColor={bgColor}
            noMarginBottom={noMarginBottom}
            extraTopPadding={extraTopPadding}
            extraBottom={extraBottom}
            className={align}
            noPaddingParent={noPaddingParent}
            zIndex={zIndex}
          >
            <div className="background--wrap" style={{backgroundColor: bgColor}}>           
              <div className="block--content" >
                <p className="preset-10 intro-title" style={{color: black}}>
                  {
                    supTitle ? 
                    supTitle
                    :
                    "Showcase"
                  }
                </p>
                <h4 className="md--title" style={{color: black}} dangerouslySetInnerHTML={{__html: title}}></h4>
                <p className="preset-10 block--text" style={{color: black}} dangerouslySetInnerHTML={{__html: text}}></p>
                {
                  route &&
                  <div className="cta--primary cursor-cta" onClick={() => handleCLick(route)}>
                    <p className="preset-10 primary-green cursor-cta" style={{color: black}} >Explore</p>
                    <svg width="14" className="next cursor-cta" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path className="cursor-cta" d="M7.66675 10.6673L13.0001 6.00065L7.66675 1.33398" stroke={black} strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                      <path className="cursor-cta" d="M13 6H1" stroke={black} strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </div>
                }
              </div>
              {children}
            </div>
            
          </StyledVideoFullSection>
          
      }
    </React.Fragment>
  );
};

export default VideoFullSection;
